import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import voca from 'voca';
import * as actions from '../redux/actions';
import { drapcodeIcon } from '../../../common/custom/icon-library';
import CopyToClipboard from 'react-copy-to-clipboard';
import TooltipInfo from '../../../common/docs/TooltipInfo';
import { description } from '../../../common/utils/event_constants';
const clipboardStyle = {
  cursor: 'pointer',
  padding: '4px',
  verticalAlign: 'middle',
  margin: 0,
};
export class ListCustomCSSCDNs extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
  };

  handleCustomCssCdnDelete = (uuid) => {
    this.props.handleCustomCssCdnDelete(uuid);
  };

  viewCustomCSSCDN = (customCssCdn) => {
    const { actions } = this.props;
    actions.fetchCssdata({
      url: customCssCdn.urlOrTag,
      uuid: customCssCdn.uuid,
      customCssCdnData: customCssCdn,
    });
  };

  renderViewCSSBtn = (customCssCdn) => {
    if (customCssCdn) {
      const { urlOrTag } = customCssCdn;
      let regex = new RegExp(/^(?:https?|ftps?):\/{2}/gm);

      if (regex.test(urlOrTag)) {
        return (
          <button
            onClick={() => this.viewCustomCSSCDN(customCssCdn)}
            title="View CSS Content"
            className="btn btn-xs btn-theme-submit"
          >
            <i className="wb webconnect-eye"></i>
          </button>
        );
      } else {
        return (
          <button
            title="Not Supported on Tags"
            className="btn btn-xs"
            disabled
            style={{ cursor: 'not-allowed' }}
          >
            <i className="wb webconnect-eye"></i>
          </button>
        );
      }
    }
  };

  render() {
    const { customCssCdns, deleteFlag, isReadOnly } = this.props;
    return (
      <div className="row mx-auto h-70 table-responsive mt-5">
        <table className="table table-bordered table-hover table-sm table-word-break">
          <thead>
            <tr>
              <th title="Index">#</th>
              <th title="Order" style={{ width: '6%' }}>
                Order #
              </th>
              <th title="Load to Builder Canvas">Load</th>
              <th title="Load to Builder Canvas">Type</th>
              <th title="URL/Link Tag" className="w-50">
                URL/Link Tag
              </th>
              <th title="Action">Action</th>
            </tr>
          </thead>
          <tbody>
            {customCssCdns.map((customCssCdn, index) => {
              return (
                <tr key={customCssCdn.uuid} className="text-left">
                  <td className="align-middle">{index + 1}</td>
                  <td className="align-middle">{customCssCdn.sortOrder}</td>
                  <td className="align-middle">
                    <span
                      className={`badge ${
                        customCssCdn.loadToBuilder ? 'badge-primary' : 'badge-theme-danger'
                      }`}
                    >
                      {customCssCdn.loadToBuilder ? 'Yes' : 'No'}
                    </span>
                  </td>
                  <td className="align-middle" title={customCssCdn.urlOrTag}>
                    {customCssCdn.customType && customCssCdn.customType === 'URL'
                      ? customCssCdn.customType
                      : voca.titleCase(voca.replaceAll(customCssCdn.customType, '_', ' '))}
                  </td>

                  <td className="align-middle" title={customCssCdn.urlOrTag}>
                    <CopyToClipboard
                      text={customCssCdn.urlOrTag ? customCssCdn.urlOrTag : ''}
                      onCopy={() => {
                        if (customCssCdn.urlOrTag) {
                          this.props.copyToClipboard(customCssCdn.urlOrTag);
                        }
                      }}
                      title={'Copy to clipboard'}
                      style={clipboardStyle}
                    >
                      <span>
                        {voca.first(customCssCdn.urlOrTag, 40)}...
                        {voca.last(customCssCdn.urlOrTag, 30)}{' '}
                        <i className="webconnect webconnect-files" />
                      </span>
                    </CopyToClipboard>
                  </td>
                  <td className="text-right">
                    {this.renderViewCSSBtn(customCssCdn)}
                    &nbsp;
                    <button
                      className="btn btn-xs btn-primary"
                      onClick={() =>
                        isReadOnly ? null : this.props.openCustomCSSCDNForm(customCssCdn.uuid)
                      }
                      title={isReadOnly ? 'Read Only' : 'Edit URL/Link Tag'}
                      disabled={isReadOnly}
                    >
                      <i className={`wb ${drapcodeIcon('edit')}`}></i>
                    </button>
                    &nbsp;
                    <button
                      className="btn btn-xs btn-theme-delete"
                      style={{ cursor: deleteFlag && !isReadOnly ? 'pointer' : 'not-allowed' }}
                      onClick={() =>
                        deleteFlag ? this.handleCustomCssCdnDelete(customCssCdn.uuid) : undefined
                      }
                      title={isReadOnly ? 'Read Only' : 'Delete URL/Link Tag'}
                      disabled={isReadOnly}
                    >
                      <i className={`wb ${drapcodeIcon('delete')}`}></i>
                      {deleteFlag ? null : (
                        <>
                          &nbsp;
                          <TooltipInfo
                            title={description}
                            headerText={`Permission Disabled!`}
                            showHeader={true}
                            showArrow={true}
                          />
                        </>
                      )}
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    projectDetail: state.projectDetail,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ListCustomCSSCDNs);
